<app-template-checkbox [disabled]="disabled" [value]="value" [disabled]="disabled" [control]="control" [options]="options" [label]="label" />
